module.exports = __webpack_public_path__ + "img/05.7345be6.png";